let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2ryVh")).then(() => parcelRequire('l252j'));